import React from 'react';

// Matches URLs (http, https, www) - supports common TLDs and path structure
const URL_REGEX = /(https?:\/\/[^\s<>]+|www\.[^\s<>]+)/gi;

/**
 * Renders text with URLs automatically converted to clickable links.
 * Opens links in a new tab with security attributes.
 */
const LinkifyText = ({ text, className }) => {
  if (!text || typeof text !== 'string') return null;

  const parts = text.split(URL_REGEX);

  return (
    <span className={className}>
      {parts.map((part, i) => {
        const isUrl =
          part.match(/^https?:\/\//i) || part.match(/^www\./i);
        if (isUrl) {
          const href = part.startsWith('www.') ? `https://${part}` : part;
          return (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="linkified-url"
            >
              {part}
            </a>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
};

export default LinkifyText;
